import { defineComponent as m, getCurrentInstance as ae, h as G, withDirectives as q, vModelDynamic as le, createElementBlock as s, openBlock as n, normalizeClass as C, createCommentVNode as g, renderSlot as c, createBlock as B, withCtx as U, useId as K, createElementVNode as r, unref as x, toDisplayString as v, mergeModels as S, useModel as E, createTextVNode as V, vShow as Z, computed as j, normalizeStyle as ne, createVNode as D, ref as z, watch as N, nextTick as W, onBeforeUnmount as J, Teleport as _, withKeys as O, withModifiers as P, Fragment as L, renderList as F, Transition as ie, vModelText as oe, normalizeProps as se, guardReactiveProps as de } from "vue";
function H(e, a, t) {
  return m({
    name: e,
    inheritAttrs: !1,
    props: {
      modelValue: {
        type: null
      },
      modelModifiers: {
        type: Object,
        default: () => ({})
      },
      compact: Boolean,
      invalid: Boolean
    },
    emits: ["update:modelValue"],
    setup(l, { attrs: i, emit: o, slots: d, expose: b }) {
      const k = ae();
      let h = null;
      return b({
        focus: () => h?.focus(),
        get element() {
          return h;
        }
      }), () => {
        const $ = G(a, {
          ...i,
          ref: (p) => h = p,
          type: t || i.type,
          class: [t === "checkbox" ? "ui-checkbox" : "ui-input", l.compact && "ui-input--compact", i.class],
          "aria-invalid": l.invalid || i["aria-invalid"],
          "onUpdate:modelValue": (p) => o("update:modelValue", p)
        }, d.default?.());
        return k?.vnode.props != null && Object.prototype.hasOwnProperty.call(k.vnode.props, "modelValue") ? q($, [[le, l.modelValue, void 0, l.modelModifiers]]) : $;
      };
    }
  });
}
const Ft = H("UiInput", "input"), Kt = H("UiTextarea", "textarea"), It = H("UiSelect", "select"), Ot = H("UiCheckbox", "input", "checkbox"), Rt = m({
  name: "UiSwitch",
  props: {
    modelValue: Boolean,
    disabled: Boolean,
    label: {
      type: String,
      required: !0
    }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: a }) {
    return () => G("button", {
      type: "button",
      role: "switch",
      "aria-checked": e.modelValue,
      "aria-label": e.label,
      disabled: e.disabled,
      class: ["ui-switch", e.modelValue && "ui-switch--on"],
      onClick: () => a("update:modelValue", !e.modelValue)
    }, G("span"));
  }
}), re = {
  white: "#ffffff",
  black: "#000000",
  neutral50: "#f9fafb",
  neutral100: "#f3f4f6",
  neutral200: "#e5e7eb",
  neutral300: "#d1d5db",
  neutral400: "#9ca3af",
  neutral500: "#6b7280",
  neutral600: "#4b5563",
  neutral700: "#374151",
  neutral800: "#1f2937",
  neutral900: "#111827",
  blue50: "#eff6ff",
  blue100: "#dbeafe",
  blue200: "#bfdbfe",
  blue300: "#93c5fd",
  blue500: "#3b82f6",
  blue600: "#2563eb",
  blue700: "#1d4ed8",
  blue900: "#1e3a8a",
  success50: "#f0fdf4",
  success200: "#bbf7d0",
  success600: "#15803d",
  success700: "#166534",
  warning50: "#fffbeb",
  warning200: "#fde68a",
  warning500: "#f59e0b",
  warning600: "#b45309",
  warning700: "#92400e",
  danger50: "#fef2f2",
  danger200: "#fecaca",
  danger600: "#dc2626",
  danger700: "#b91c1c",
  categoryPurple: "#7c3aed",
  categoryTeal: "#0f766e",
  categoryPink: "#be185d"
}, ue = {
  surface: "#ffffff",
  "surface-muted": "#f9fafb",
  "surface-hover": "#f3f4f6",
  text: "#1f2937",
  "text-muted": "#6b7280",
  "text-subtle": "#4b5563",
  border: "#e5e7eb",
  "border-control": "#e5e7eb",
  "focus-ring": "#2563eb",
  primary: "#2563eb",
  "primary-hover": "#1d4ed8",
  "on-primary": "#ffffff",
  selected: "#eff6ff",
  "selected-text": "#1d4ed8",
  overlay: "#000000",
  success: "#15803d",
  "success-text": "#166534",
  "success-surface": "#f0fdf4",
  "success-border": "#bbf7d0",
  warning: "#b45309",
  "warning-text": "#92400e",
  "warning-surface": "#fffbeb",
  "warning-border": "#fde68a",
  danger: "#dc2626",
  "danger-text": "#b91c1c",
  "danger-surface": "#fef2f2",
  "danger-border": "#fecaca",
  info: "#2563eb",
  "info-text": "#1d4ed8",
  "info-surface": "#eff6ff",
  "info-border": "#bfdbfe"
}, qt = re, jt = ue, Nt = {
  surface: "white",
  "surface-muted": "neutral50",
  "surface-hover": "neutral100",
  text: "neutral800",
  "text-muted": "neutral500",
  "text-subtle": "neutral600",
  border: "neutral200",
  "border-control": "neutral200",
  "focus-ring": "blue600",
  primary: "blue600",
  "primary-hover": "blue700",
  "on-primary": "white",
  selected: "blue50",
  "selected-text": "blue700",
  overlay: "black",
  success: "success600",
  "success-text": "success700",
  "success-surface": "success50",
  "success-border": "success200",
  warning: "warning600",
  "warning-text": "warning700",
  "warning-surface": "warning50",
  "warning-border": "warning200",
  danger: "danger600",
  "danger-text": "danger700",
  "danger-surface": "danger50",
  "danger-border": "danger200",
  info: "blue600",
  "info-text": "blue700",
  "info-surface": "blue50",
  "info-border": "blue200"
}, Ht = {
  "space-1": "4px",
  "space-2": "8px",
  "space-3": "12px",
  "space-4": "16px",
  "space-6": "24px",
  "space-8": "32px",
  "text-xs": "12px",
  "text-sm": "14px",
  "text-base": "16px",
  "text-lg": "18px",
  "text-xl": "24px",
  "radius-sm": "4px",
  "radius-md": "8px",
  "radius-lg": "16px",
  "size-sm": "28px",
  "size-md": "36px",
  "size-lg": "44px",
  "font-sans": "ui-sans-serif, system-ui, sans-serif",
  "font-mono": "ui-monospace, SFMono-Regular, Consolas, monospace",
  duration: "180ms",
  "panel-width": "18rem"
}, Gt = [
  "#2563eb",
  "#15803d",
  "#b45309",
  "#dc2626",
  "#7c3aed",
  "#0f766e",
  "#be185d"
], ce = ["type", "disabled", "aria-busy"], fe = {
  key: 0,
  class: "ui-spinner",
  "aria-hidden": "true"
}, I = /* @__PURE__ */ m({
  __name: "UiButton",
  props: {
    variant: { default: "secondary" },
    size: { default: "md" },
    shape: { default: "default" },
    tone: { default: "neutral" },
    disabled: { type: Boolean },
    loading: { type: Boolean },
    type: { default: "button" }
  },
  setup(e) {
    return (a, t) => (n(), s("button", {
      type: e.type,
      disabled: e.disabled || e.loading,
      "aria-busy": e.loading || void 0,
      class: C(["ui-button", ["ui-button--" + e.variant, "ui-size--" + e.size, { "ui-button--pill": e.shape === "pill" }, e.shape === "pill" ? "ui-tone--" + e.tone : void 0]])
    }, [
      e.loading ? (n(), s("span", fe)) : g("", !0),
      c(a.$slots, "default")
    ], 10, ce));
  }
}), A = /* @__PURE__ */ m({
  __name: "UiIconButton",
  props: {
    label: {},
    variant: { default: "ghost" },
    size: { default: "md" },
    disabled: { type: Boolean }
  },
  setup(e) {
    return (a, t) => (n(), B(I, {
      variant: e.variant,
      size: e.size,
      disabled: e.disabled,
      "aria-label": e.label,
      title: e.label,
      class: "ui-icon-button"
    }, {
      default: U(() => [
        c(a.$slots, "default")
      ]),
      _: 3
    }, 8, ["variant", "size", "disabled", "aria-label", "title"]));
  }
}), be = ["href"], Wt = /* @__PURE__ */ m({
  __name: "UiLink",
  props: {
    href: {}
  },
  setup(e) {
    return (a, t) => (n(), s("a", {
      href: e.href,
      class: "ui-link"
    }, [
      c(a.$slots, "default")
    ], 8, be));
  }
}), me = ["aria-label"], ve = /* @__PURE__ */ m({
  __name: "UiButtonGroup",
  props: {
    label: {}
  },
  setup(e) {
    return (a, t) => (n(), s("div", {
      role: "group",
      "aria-label": e.label,
      class: "ui-button-group"
    }, [
      c(a.$slots, "default")
    ], 8, me));
  }
}), pe = { class: "ui-field" }, ye = ["for"], ge = ["id", "role"], Jt = /* @__PURE__ */ m({
  __name: "UiField",
  props: {
    id: {},
    label: {},
    help: {},
    error: {}
  },
  setup(e) {
    const a = e, t = K();
    return (l, i) => (n(), s("div", pe, [
      r("label", {
        for: a.id || x(t)
      }, v(e.label), 9, ye),
      c(l.$slots, "default", {
        id: a.id || x(t),
        describedby: e.help || e.error ? (a.id || x(t)) + "-message" : void 0,
        invalid: !!e.error
      }),
      e.help || e.error ? (n(), s("p", {
        key: 0,
        id: (a.id || x(t)) + "-message",
        class: C({ "ui-error": e.error }),
        role: e.error ? "alert" : void 0
      }, v(e.error || e.help), 11, ge)) : g("", !0)
    ]));
  }
}), he = /* @__PURE__ */ m({
  __name: "UiBadge",
  props: {
    tone: { default: "neutral" }
  },
  setup(e) {
    return (a, t) => (n(), s("span", {
      class: C(["ui-badge", "ui-tone--" + e.tone])
    }, [
      c(a.$slots, "default")
    ], 2));
  }
}), $e = ["role"], Qt = /* @__PURE__ */ m({
  __name: "UiAlert",
  props: {
    tone: { default: "info" }
  },
  setup(e) {
    return (a, t) => (n(), s("div", {
      role: e.tone === "danger" ? "alert" : "status",
      class: C(["ui-alert", "ui-tone--" + e.tone])
    }, [
      c(a.$slots, "default")
    ], 10, $e));
  }
}), ke = ["aria-label"], we = /* @__PURE__ */ m({
  __name: "UiSpinner",
  props: {
    label: { default: "Loading" }
  },
  setup(e) {
    return (a, t) => (n(), s("span", {
      role: "status",
      "aria-label": e.label,
      class: "ui-spinner"
    }, null, 8, ke));
  }
}), Ue = { class: "ui-empty" }, xe = { key: 0 }, Xt = /* @__PURE__ */ m({
  __name: "UiEmptyState",
  props: {
    title: {},
    description: {}
  },
  setup(e) {
    return (a, t) => (n(), s("div", Ue, [
      c(a.$slots, "icon"),
      r("p", null, v(e.title), 1),
      e.description ? (n(), s("p", xe, v(e.description), 1)) : g("", !0),
      c(a.$slots, "default")
    ]));
  }
}), ee = (e, a) => {
  const t = e.__vccOpts || e;
  for (const [l, i] of a)
    t[l] = i;
  return t;
}, Be = {}, Ce = { class: "ui-separator" };
function Me(e, a) {
  return n(), s("hr", Ce);
}
const Yt = /* @__PURE__ */ ee(Be, [["render", Me]]), Zt = /* @__PURE__ */ m({
  __name: "UiSurface",
  props: {
    muted: { type: Boolean }
  },
  setup(e) {
    return (a, t) => (n(), s("div", {
      class: C(["ui-surface", { "ui-surface--muted": e.muted }])
    }, [
      c(a.$slots, "default")
    ], 2));
  }
}), Se = { class: "ui-section" }, ze = ["aria-expanded", "aria-controls"], Ve = { "aria-hidden": "true" }, De = ["id"], _t = /* @__PURE__ */ m({
  __name: "UiCollapsible",
  props: /* @__PURE__ */ S({
    title: {}
  }, {
    open: { type: Boolean, default: !0 },
    openModifiers: {}
  }),
  emits: ["update:open"],
  setup(e) {
    const a = E(e, "open"), t = K();
    return (l, i) => (n(), s("section", Se, [
      r("button", {
        type: "button",
        class: "ui-section-heading",
        "aria-expanded": a.value,
        "aria-controls": x(t),
        onClick: i[0] || (i[0] = (o) => a.value = !a.value)
      }, [
        V(v(e.title) + " ", 1),
        r("span", Ve, v(a.value ? "−" : "+"), 1)
      ], 8, ze),
      q(r("div", { id: x(t) }, [
        c(l.$slots, "default")
      ], 8, De), [
        [Z, a.value]
      ])
    ]));
  }
}), Te = { class: "ui-panel-section" }, ea = /* @__PURE__ */ m({
  __name: "UiPanelSection",
  props: {
    title: {}
  },
  setup(e) {
    return (a, t) => (n(), s("section", Te, [
      r("header", null, [
        r("h3", null, v(e.title), 1),
        c(a.$slots, "actions")
      ]),
      c(a.$slots, "default")
    ]));
  }
}), Le = ["aria-pressed", "disabled"], ta = /* @__PURE__ */ m({
  __name: "UiPanelAction",
  props: {
    selected: { type: Boolean },
    disabled: { type: Boolean }
  },
  setup(e) {
    return (a, t) => (n(), s("button", {
      type: "button",
      class: C(["ui-panel-action", { "ui-panel-action--selected": e.selected }]),
      "aria-pressed": e.selected,
      disabled: e.disabled
    }, [
      c(a.$slots, "default")
    ], 10, Le));
  }
}), aa = /* @__PURE__ */ m({
  __name: "UiPanelToggle",
  props: {
    side: {},
    open: { type: Boolean },
    label: {},
    controls: {}
  },
  emits: ["update:open"],
  setup(e) {
    return (a, t) => (n(), B(A, {
      label: e.label,
      "aria-expanded": e.open,
      "aria-controls": e.controls,
      onClick: t[0] || (t[0] = (l) => a.$emit("update:open", !e.open))
    }, {
      default: U(() => [
        c(a.$slots, "default", {}, () => [
          V(v(e.side === "left" ? "☰" : "⋮"), 1)
        ])
      ]),
      _: 3
    }, 8, ["label", "aria-expanded", "aria-controls"]));
  }
}), Ae = ["title", "aria-label"], Y = /* @__PURE__ */ m({
  __name: "UiAvatar",
  props: {
    name: { default: "" },
    secondaryText: {},
    color: {},
    size: { default: "md" }
  },
  setup(e) {
    const a = e, t = j(() => {
      const l = (a.name || a.secondaryText || "?").trim().split(/\s+/);
      return (l.length > 1 ? l[0][0] + l[1][0] : l[0].slice(0, 2)).toUpperCase();
    });
    return (l, i) => (n(), s("span", {
      class: C(["ui-avatar", "ui-size--" + e.size]),
      style: ne(e.color ? { backgroundColor: e.color } : void 0),
      title: e.name || e.secondaryText,
      "aria-label": e.name || e.secondaryText
    }, v(t.value), 15, Ae));
  }
}), Ee = /* @__PURE__ */ m({
  __name: "UiPartControls",
  props: {
    canMoveUp: { type: Boolean },
    canMoveDown: { type: Boolean },
    removable: { type: Boolean },
    disabled: { type: Boolean }
  },
  emits: ["move", "remove"],
  setup(e) {
    return (a, t) => (n(), B(ve, { label: "Part actions" }, {
      default: U(() => [
        D(A, {
          label: "Move part up",
          size: "sm",
          disabled: e.disabled || !e.canMoveUp,
          onClick: t[0] || (t[0] = (l) => a.$emit("move", -1))
        }, {
          default: U(() => [...t[3] || (t[3] = [
            r("svg", {
              class: "ui-control-icon",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "2.5",
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "aria-hidden": "true"
            }, [
              r("path", { d: "M12 19V5m-6 6 6-6 6 6" })
            ], -1)
          ])]),
          _: 1
        }, 8, ["disabled"]),
        D(A, {
          label: "Move part down",
          size: "sm",
          disabled: e.disabled || !e.canMoveDown,
          onClick: t[1] || (t[1] = (l) => a.$emit("move", 1))
        }, {
          default: U(() => [...t[4] || (t[4] = [
            r("svg", {
              class: "ui-control-icon",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "2.5",
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "aria-hidden": "true"
            }, [
              r("path", { d: "M12 5v14m-6-6 6 6 6-6" })
            ], -1)
          ])]),
          _: 1
        }, 8, ["disabled"]),
        e.removable ? (n(), B(A, {
          key: 0,
          label: "Remove part",
          size: "sm",
          disabled: e.disabled,
          onClick: t[2] || (t[2] = (l) => a.$emit("remove"))
        }, {
          default: U(() => [...t[5] || (t[5] = [
            r("svg", {
              class: "ui-control-icon",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "2.5",
              "stroke-linecap": "round",
              "aria-hidden": "true"
            }, [
              r("path", { d: "M5 5 19 19M19 5 5 19" })
            ], -1)
          ])]),
          _: 1
        }, 8, ["disabled"])) : g("", !0)
      ]),
      _: 1
    }));
  }
}), Pe = { class: "ui-part-section" }, Fe = { key: 0 }, Ke = ["value", "disabled"], Ie = ["aria-expanded", "aria-controls"], Oe = ["id"], la = /* @__PURE__ */ m({
  __name: "UiPartSection",
  props: /* @__PURE__ */ S({
    title: {},
    editableTitle: { type: Boolean },
    canMoveUp: { type: Boolean },
    canMoveDown: { type: Boolean },
    removable: { type: Boolean },
    disabled: { type: Boolean }
  }, {
    collapsed: { type: Boolean, default: !1 },
    collapsedModifiers: {}
  }),
  emits: /* @__PURE__ */ S(["update:title", "move", "remove"], ["update:collapsed"]),
  setup(e) {
    const a = E(e, "collapsed"), t = K();
    return (l, i) => (n(), s("section", Pe, [
      e.title || l.$slots.heading ? (n(), s("header", Fe, [
        c(l.$slots, "heading", {}, () => [
          e.editableTitle ? (n(), s("input", {
            key: 0,
            value: e.title,
            "aria-label": "Section title",
            disabled: e.disabled,
            class: "ui-input",
            onInput: i[0] || (i[0] = (o) => l.$emit("update:title", o.target.value))
          }, null, 40, Ke)) : (n(), s("button", {
            key: 1,
            type: "button",
            "aria-expanded": !a.value,
            "aria-controls": x(t),
            onClick: i[1] || (i[1] = (o) => a.value = !a.value)
          }, v(e.title), 9, Ie))
        ]),
        c(l.$slots, "actions", {}, () => [
          e.canMoveUp || e.canMoveDown || e.removable ? (n(), B(Ee, {
            key: 0,
            "can-move-up": e.canMoveUp,
            "can-move-down": e.canMoveDown,
            removable: e.removable,
            disabled: e.disabled,
            onMove: i[2] || (i[2] = (o) => l.$emit("move", o)),
            onRemove: i[3] || (i[3] = (o) => l.$emit("remove"))
          }, null, 8, ["can-move-up", "can-move-down", "removable", "disabled"])) : g("", !0)
        ])
      ])) : g("", !0),
      q(r("div", { id: x(t) }, [
        c(l.$slots, "default")
      ], 8, Oe), [
        [Z, !a.value]
      ])
    ]));
  }
}), T = [], R = /* @__PURE__ */ new Set();
let te = "";
function Re(e) {
  R.size === 0 && (te = document.body.style.overflow, document.body.style.overflow = "hidden"), R.add(e);
}
function qe(e) {
  R.delete(e) && R.size === 0 && (document.body.style.overflow = te);
}
const je = ["aria-labelledby"], Ne = ["id"], He = { key: 0 }, na = /* @__PURE__ */ m({
  __name: "UiDialog",
  props: /* @__PURE__ */ S({
    title: {},
    dismissible: { type: Boolean, default: !0 }
  }, {
    open: { type: Boolean, default: !1 },
    openModifiers: {}
  }),
  emits: ["update:open"],
  setup(e) {
    const a = E(e, "open"), t = z(), l = K(), i = /* @__PURE__ */ Symbol();
    let o = null;
    function d(f) {
      a.value && T.at(-1) === i && !t.value?.contains(f.target) && (b()[0] || t.value)?.focus();
    }
    const b = () => Array.from(t.value?.querySelectorAll('button:not(:disabled),a[href],input:not(:disabled),select:not(:disabled),textarea:not(:disabled),[tabindex="0"]') || []).filter((f) => f.getClientRects().length);
    function k(f) {
      if (T.at(-1) === i && f.key === "Tab") {
        const p = b(), y = p[0] || t.value, u = p.at(-1) || t.value;
        (!p.length || f.shiftKey && document.activeElement === y || !f.shiftKey && document.activeElement === u) && (f.preventDefault(), (f.shiftKey ? u : y)?.focus());
      }
    }
    N(a, async (f) => {
      f ? (o = document.activeElement, T.push(i), Re(i), document.addEventListener("keydown", k), document.addEventListener("focusin", d), await W(), (b()[0] || t.value)?.focus()) : h();
    }, {
      immediate: !0
    });
    function h() {
      const f = T.indexOf(i);
      f >= 0 && (T.splice(f, 1), o?.focus()), qe(i), document.removeEventListener("keydown", k), document.removeEventListener("focusin", d);
    }
    J(h);
    function $(f) {
      f && T.at(-1) === i && (a.value = !1);
    }
    return (f, p) => (n(), B(_, { to: "body" }, [
      a.value ? (n(), s("div", {
        key: 0,
        class: "ui-overlay",
        onClick: p[1] || (p[1] = P((y) => $(e.dismissible !== !1), ["self"])),
        onKeydown: p[2] || (p[2] = O(P((y) => $(e.dismissible !== !1), ["stop"]), ["esc"]))
      }, [
        r("section", {
          ref_key: "panel",
          ref: t,
          class: "ui-dialog",
          role: "dialog",
          "aria-modal": "true",
          "aria-labelledby": x(l),
          tabindex: "-1"
        }, [
          r("header", null, [
            r("h2", { id: x(l) }, v(e.title), 9, Ne),
            e.dismissible !== !1 ? (n(), B(A, {
              key: 0,
              label: "Close dialog",
              onClick: p[0] || (p[0] = (y) => a.value = !1)
            }, {
              default: U(() => [...p[3] || (p[3] = [
                r("svg", {
                  class: "ui-control-icon ui-control-icon--dialog",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "2.5",
                  "stroke-linecap": "round",
                  "aria-hidden": "true"
                }, [
                  r("path", { d: "M5 5 19 19M19 5 5 19" })
                ], -1)
              ])]),
              _: 1
            })) : g("", !0)
          ]),
          c(f.$slots, "default"),
          f.$slots.footer ? (n(), s("footer", He, [
            c(f.$slots, "footer")
          ])) : g("", !0)
        ], 8, je)
      ], 32)) : g("", !0)
    ]));
  }
}), Ge = ["id", "aria-label"], Q = /* @__PURE__ */ m({
  __name: "UiPopover",
  props: /* @__PURE__ */ S({
    label: {}
  }, {
    open: { type: Boolean, default: !1 },
    openModifiers: {}
  }),
  emits: ["update:open"],
  setup(e) {
    const a = E(e, "open"), t = z(), l = z(), i = K(), o = /* @__PURE__ */ Symbol();
    let d = null;
    function b() {
      const $ = t.value?.getBoundingClientRect(), f = l.value;
      if (!$ || !f)
        return;
      const p = f.getBoundingClientRect(), y = Math.max(8, Math.min($.right - p.width, innerWidth - p.width - 8)), u = $.bottom + 8, w = u + p.height <= innerHeight - 8 ? u : Math.max(8, $.top - p.height - 8);
      Object.assign(f.style, {
        position: "fixed",
        left: `${y}px`,
        top: `${w}px`,
        right: "auto"
      });
    }
    function k($) {
      const f = $.target;
      !t.value?.contains(f) && !l.value?.contains(f) && (a.value = !1);
    }
    function h() {
      const $ = T.indexOf(o);
      $ >= 0 && T.splice($, 1), document.removeEventListener("pointerdown", k), window.removeEventListener("resize", b), window.removeEventListener("scroll", b, !0);
    }
    return N(a, async ($) => {
      $ ? (T.push(o), d = document.activeElement, document.addEventListener("pointerdown", k), window.addEventListener("resize", b), window.addEventListener("scroll", b, !0), await W(), b(), (l.value?.querySelector('[role="menuitem"]:not(:disabled)') || l.value)?.focus()) : (h(), d?.focus());
    }, {
      immediate: !0
    }), J(h), ($, f) => (n(), s("div", {
      ref_key: "root",
      ref: t,
      class: "ui-popover-anchor",
      onKeydown: f[1] || (f[1] = O(P((p) => a.value = !1, ["stop"]), ["esc"]))
    }, [
      c($.$slots, "trigger", {
        open: a.value,
        toggle: () => a.value = !a.value,
        controls: x(i)
      }),
      (n(), B(_, { to: "body" }, [
        a.value ? (n(), s("div", {
          key: 0,
          id: x(i),
          ref_key: "content",
          ref: l,
          class: "ui-popover ui-menu-surface",
          "aria-label": e.label,
          tabindex: "-1",
          onKeydown: f[0] || (f[0] = O(P((p) => a.value = !1, ["stop"]), ["esc"]))
        }, [
          c($.$slots, "default", {
            close: () => a.value = !1
          })
        ], 40, Ge)) : g("", !0)
      ]))
    ], 544));
  }
}), We = ["aria-label"], Je = {
  key: 0,
  role: "separator",
  class: "ui-separator"
}, Qe = {
  key: 1,
  class: "ui-menu-label"
}, Xe = ["aria-label", "disabled", "onClick"], Ye = /* @__PURE__ */ m({
  __name: "UiMenu",
  props: {
    groups: {},
    label: {}
  },
  emits: ["select"],
  setup(e) {
    function a(t) {
      const l = Array.from(t.currentTarget.querySelectorAll("[role=menuitem]:not(:disabled)")), i = l.indexOf(document.activeElement);
      let o = i;
      if (t.key === "ArrowDown")
        o = (i + 1) % l.length;
      else if (t.key === "ArrowUp")
        o = (i - 1 + l.length) % l.length;
      else if (t.key === "Home")
        o = 0;
      else if (t.key === "End")
        o = l.length - 1;
      else
        return;
      t.preventDefault(), l[o]?.focus();
    }
    return (t, l) => (n(), s("div", {
      role: "menu",
      "aria-label": e.label,
      onKeydown: a
    }, [
      (n(!0), s(L, null, F(e.groups, (i, o) => (n(), s(L, { key: o }, [
        o ? (n(), s("div", Je)) : g("", !0),
        i.label ? (n(), s("div", Qe, v(i.label), 1)) : g("", !0),
        (n(!0), s(L, null, F(i.actions, (d) => (n(), s("button", {
          key: d.id,
          type: "button",
          role: "menuitem",
          class: C(["ui-menu-item", { "ui-menu-item--danger": d.danger }]),
          "aria-label": d.ariaLabel,
          disabled: d.disabled,
          onClick: (b) => t.$emit("select", d.id)
        }, [
          d.icon ? (n(), s("i", {
            key: 0,
            class: C(d.icon),
            "aria-hidden": "true"
          }, null, 2)) : g("", !0),
          V(v(d.label), 1)
        ], 10, Xe))), 128))
      ], 64))), 128)),
      c(t.$slots, "default")
    ], 40, We));
  }
}), Ze = { class: "ui-user-menu-content" }, _e = { class: "ui-user-menu-heading" }, ia = /* @__PURE__ */ m({
  __name: "UiUserMenu",
  props: /* @__PURE__ */ S({
    name: {},
    secondaryText: {},
    color: {},
    groups: {},
    size: { default: "md" }
  }, {
    open: { type: Boolean, default: !1 },
    openModifiers: {}
  }),
  emits: /* @__PURE__ */ S(["select"], ["update:open"]),
  setup(e) {
    const a = E(e, "open");
    return (t, l) => (n(), B(Q, {
      open: a.value,
      "onUpdate:open": l[1] || (l[1] = (i) => a.value = i),
      label: "User menu"
    }, {
      trigger: U(({ toggle: i, controls: o }) => [
        D(A, {
          size: e.size,
          label: "User menu for " + e.name,
          "aria-expanded": a.value,
          "aria-controls": o,
          "aria-haspopup": "menu",
          onClick: i
        }, {
          default: U(() => [
            D(Y, {
              name: e.name,
              color: e.color,
              size: e.size
            }, null, 8, ["name", "color", "size"])
          ]),
          _: 1
        }, 8, ["size", "label", "aria-expanded", "aria-controls", "onClick"])
      ]),
      default: U(() => [
        r("div", Ze, [
          r("header", _e, [
            D(Y, {
              name: e.name,
              color: e.color,
              size: "lg"
            }, null, 8, ["name", "color"]),
            r("div", null, [
              V(v(e.name), 1),
              r("small", null, v(e.secondaryText), 1),
              c(t.$slots, "badge")
            ])
          ]),
          e.groups ? (n(), B(Ye, {
            key: 0,
            groups: e.groups,
            label: "Account actions",
            onSelect: l[0] || (l[0] = (i) => {
              t.$emit("select", i), a.value = !1;
            })
          }, null, 8, ["groups"])) : g("", !0),
          c(t.$slots, "default"),
          c(t.$slots, "accounts")
        ])
      ]),
      _: 3
    }, 8, ["open"]));
  }
}), et = {
  key: 1,
  "aria-hidden": "true"
}, tt = {
  key: 0,
  class: "ui-sync-count"
}, oa = /* @__PURE__ */ m({
  __name: "UiSyncStatus",
  props: /* @__PURE__ */ S({
    state: {},
    label: {},
    pending: {},
    compact: { type: Boolean }
  }, {
    open: { type: Boolean, default: !1 },
    openModifiers: {}
  }),
  emits: /* @__PURE__ */ S(["activate", "action"], ["update:open"]),
  setup(e) {
    const a = E(e, "open");
    return (t, l) => (n(), B(Q, {
      open: a.value,
      "onUpdate:open": l[0] || (l[0] = (i) => a.value = i),
      label: e.label
    }, {
      trigger: U(({ toggle: i, controls: o }) => [
        r("span", {
          class: C(["ui-sync", "ui-sync--" + e.state])
        }, [
          D(A, {
            label: e.label,
            variant: e.compact ? "ghost" : "secondary",
            "aria-expanded": a.value,
            "aria-controls": o,
            onClick: (d) => {
              i(), t.$emit("activate");
            }
          }, {
            default: U(() => [
              e.state === "syncing" ? (n(), B(we, {
                key: 0,
                label: e.label
              }, null, 8, ["label"])) : (n(), s("span", et, v(e.state === "synced" ? "✓" : e.state === "error" ? "!" : e.state === "offline" ? "☁" : "↑"), 1))
            ]),
            _: 1
          }, 8, ["label", "variant", "aria-expanded", "aria-controls", "onClick"]),
          e.pending ? (n(), s("span", tt, v(e.pending), 1)) : g("", !0)
        ], 2)
      ]),
      default: U(() => [
        r("p", null, [
          r("strong", null, v(e.label), 1)
        ]),
        c(t.$slots, "details"),
        c(t.$slots, "actions", {
          action: (i) => t.$emit("action", i)
        })
      ]),
      _: 3
    }, 8, ["open", "label"]));
  }
}), at = ["data-side", "aria-label"], lt = { key: 0 }, nt = { key: 1 }, sa = /* @__PURE__ */ m({
  __name: "UiSidePanel",
  props: /* @__PURE__ */ S({
    side: {},
    title: {},
    showHeader: { type: Boolean, default: !0 }
  }, {
    open: { type: Boolean, default: !1 },
    openModifiers: {}
  }),
  emits: ["update:open"],
  setup(e) {
    const a = E(e, "open"), t = z();
    let l = null;
    N(a, async (o) => {
      o && matchMedia("(max-width:639px)").matches ? (l = document.activeElement, await W(), (t.value?.querySelector("button") || t.value)?.focus()) : o || l?.focus();
    }, {
      immediate: !0
    });
    function i(o) {
      if (o.key !== "Tab" || !matchMedia("(max-width:639px)").matches)
        return;
      const d = Array.from(t.value?.querySelectorAll('button:not(:disabled),input:not(:disabled),select:not(:disabled),textarea:not(:disabled),a[href],[tabindex="0"]') || []).filter((h) => h.getClientRects().length), b = d[0] || t.value, k = d.at(-1) || t.value;
      (!d.length || o.shiftKey && document.activeElement === b || !o.shiftKey && document.activeElement === k) && (o.preventDefault(), (o.shiftKey ? k : b)?.focus());
    }
    return (o, d) => (n(), B(ie, { name: "ui-side-panel" }, {
      default: U(() => [
        a.value ? (n(), s("aside", {
          key: 0,
          ref_key: "panel",
          ref: t,
          tabindex: "-1",
          class: "ui-side-panel",
          "data-side": e.side,
          "aria-label": e.title || e.side + " panel",
          onKeydown: [
            i,
            d[1] || (d[1] = O(P((b) => a.value = !1, ["stop"]), ["esc"]))
          ]
        }, [
          e.showHeader && (e.title || o.$slots.header) ? (n(), s("header", lt, [
            c(o.$slots, "header", {}, () => [
              r("h2", null, v(e.title), 1),
              D(A, {
                label: "Close " + (e.title || e.side + " panel"),
                onClick: d[0] || (d[0] = (b) => a.value = !1)
              }, {
                default: U(() => [...d[2] || (d[2] = [
                  V("×", -1)
                ])]),
                _: 1
              }, 8, ["label"])
            ])
          ])) : g("", !0),
          c(o.$slots, "default"),
          o.$slots.footer ? (n(), s("footer", nt, [
            c(o.$slots, "footer")
          ])) : g("", !0)
        ], 40, at)) : g("", !0)
      ]),
      _: 3
    }));
  }
}), it = ["aria-label"], ot = ["aria-selected", "tabindex", "disabled", "onClick"], da = /* @__PURE__ */ m({
  __name: "UiTabs",
  props: /* @__PURE__ */ S({
    options: {},
    label: {}
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const a = E(e, "modelValue");
    function t(l) {
      const i = Array.from(l.currentTarget.querySelectorAll("button:not(:disabled)")), o = i.indexOf(document.activeElement), d = l.key === "ArrowRight" ? (o + 1) % i.length : l.key === "ArrowLeft" ? (o - 1 + i.length) % i.length : l.key === "Home" ? 0 : l.key === "End" ? i.length - 1 : -1;
      d >= 0 && (l.preventDefault(), i[d]?.focus(), i[d]?.click());
    }
    return (l, i) => (n(), s("div", {
      role: "tablist",
      "aria-label": e.label,
      class: "ui-tabs",
      onKeydown: t
    }, [
      (n(!0), s(L, null, F(e.options, (o) => (n(), s("button", {
        key: o.value,
        role: "tab",
        type: "button",
        class: "ui-tab",
        "aria-selected": a.value === o.value,
        tabindex: a.value === o.value ? 0 : -1,
        disabled: o.disabled,
        onClick: (d) => a.value = o.value
      }, v(o.label), 9, ot))), 128))
    ], 40, it));
  }
}), st = { class: "ui-multiselect-values" }, dt = ["disabled", "aria-label", "onClick"], rt = ["aria-label", "aria-expanded", "aria-controls", "aria-activedescendant", "placeholder", "disabled"], ut = ["id", "aria-label"], ct = {
  key: 0,
  role: "status"
}, ft = ["id", "aria-disabled", "onPointerdown"], bt = { key: 1 }, ra = /* @__PURE__ */ m({
  __name: "UiMultiSelect",
  props: {
    modelValue: {},
    options: {},
    label: {},
    placeholder: { default: "Search" },
    disabled: { type: Boolean },
    loading: { type: Boolean },
    remote: { type: Boolean }
  },
  emits: ["update:modelValue", "search"],
  setup(e, { emit: a }) {
    const t = e, l = a, i = z(""), o = z(!1), d = z(0), b = K(), k = z(), h = j(() => t.options.filter((y) => !t.modelValue.includes(y.value) && (t.remote || y.label.toLowerCase().includes(i.value.toLowerCase()))));
    function $(y) {
      t.disabled || (l("update:modelValue", [...t.modelValue, y]), i.value = "", o.value = !1, l("search", ""));
    }
    function f(y) {
      if (y.key === "ArrowDown" || y.key === "ArrowUp")
        y.preventDefault(), o.value = !0, d.value = Math.max(0, Math.min(h.value.length - 1, d.value + (y.key === "ArrowDown" ? 1 : -1)));
      else if (y.key === "Enter" && o.value) {
        y.preventDefault();
        const u = h.value[d.value];
        u && !u.disabled && $(u.value);
      } else y.key === "Escape" && (y.stopPropagation(), o.value = !1);
    }
    function p(y) {
      k.value?.contains(y.target) || (o.value = !1);
    }
    return document.addEventListener("pointerdown", p), J(() => document.removeEventListener("pointerdown", p)), (y, u) => (n(), s("div", {
      ref_key: "root",
      ref: k,
      class: "ui-multiselect"
    }, [
      r("div", st, [
        (n(!0), s(L, null, F(e.modelValue, (w) => (n(), B(he, {
          key: w,
          tone: "info"
        }, {
          default: U(() => [
            V(v(e.options.find((M) => M.value === w)?.label || w), 1),
            r("button", {
              type: "button",
              disabled: e.disabled,
              "aria-label": "Remove " + (e.options.find((M) => M.value === w)?.label || w),
              onClick: (M) => l("update:modelValue", e.modelValue.filter((X) => X !== w))
            }, "×", 8, dt)
          ]),
          _: 2
        }, 1024))), 128))
      ]),
      q(r("input", {
        "onUpdate:modelValue": u[0] || (u[0] = (w) => i.value = w),
        role: "combobox",
        "aria-autocomplete": "list",
        "aria-label": e.label,
        "aria-expanded": o.value,
        "aria-controls": x(b),
        "aria-activedescendant": o.value && h.value[d.value] ? x(b) + "-" + d.value : void 0,
        placeholder: e.placeholder,
        disabled: e.disabled,
        class: "ui-input",
        onFocus: u[1] || (u[1] = (w) => o.value = !0),
        onInput: u[2] || (u[2] = (w) => {
          d.value = 0, o.value = !0, l("search", i.value);
        }),
        onKeydown: f
      }, null, 40, rt), [
        [oe, i.value]
      ]),
      o.value ? (n(), s("div", {
        key: 0,
        id: x(b),
        role: "listbox",
        "aria-label": e.label,
        class: "ui-listbox"
      }, [
        e.loading ? (n(), s("div", ct, "Loading…")) : g("", !0),
        (n(!0), s(L, null, F(h.value, (w, M) => (n(), s("div", {
          id: x(b) + "-" + M,
          key: w.value,
          role: "option",
          "aria-selected": !1,
          "aria-disabled": w.disabled,
          class: C(["ui-option", { "ui-option--active": d.value === M }]),
          onPointerdown: P((X) => !w.disabled && $(w.value), ["prevent"])
        }, [
          c(y.$slots, "option", { option: w }, () => [
            V(v(w.label), 1)
          ])
        ], 42, ft))), 128)),
        !e.loading && !h.value.length ? (n(), s("div", bt, "No matching options")) : g("", !0)
      ], 8, ut)) : g("", !0)
    ], 512));
  }
}), mt = { class: "ui-date-time-field" }, vt = { class: "ui-date-time-field__control" }, pt = ["value", "disabled", "aria-label"], yt = { class: "ui-date-time-field__control" }, gt = ["value", "disabled", "aria-label"], ht = {
  key: 0,
  class: "ui-date-time-field__actions"
}, $t = {
  key: 0,
  class: "ui-date-time-field__action-group"
}, kt = {
  key: 1,
  class: "ui-date-time-field__action-group"
}, ua = /* @__PURE__ */ m({
  __name: "UiDateTimeField",
  props: {
    date: {},
    time: { default: "" },
    dateLabel: { default: "Date" },
    timeLabel: { default: "Time (optional)" },
    disabled: { type: Boolean }
  },
  emits: ["update:date", "update:time"],
  setup(e) {
    return (a, t) => (n(), s("div", mt, [
      r("label", vt, [
        r("span", null, v(e.dateLabel), 1),
        r("input", {
          value: e.date,
          type: "date",
          disabled: e.disabled,
          "aria-label": e.dateLabel,
          class: "ui-input",
          onInput: t[0] || (t[0] = (l) => a.$emit("update:date", l.target.value))
        }, null, 40, pt)
      ]),
      r("label", yt, [
        r("span", null, v(e.timeLabel), 1),
        r("input", {
          value: e.time,
          type: "time",
          disabled: e.disabled,
          "aria-label": e.timeLabel,
          class: "ui-input",
          onInput: t[1] || (t[1] = (l) => a.$emit("update:time", l.target.value))
        }, null, 40, gt)
      ]),
      a.$slots["date-actions"] || a.$slots["time-actions"] ? (n(), s("div", ht, [
        a.$slots["date-actions"] ? (n(), s("div", $t, [
          c(a.$slots, "date-actions")
        ])) : g("", !0),
        a.$slots["time-actions"] ? (n(), s("div", kt, [
          c(a.$slots, "time-actions")
        ])) : g("", !0)
      ])) : g("", !0)
    ]));
  }
}), wt = ["data-drag-active"], Ut = ["multiple", "accept", "disabled"], xt = ["disabled"], ca = /* @__PURE__ */ m({
  __name: "UiFileDropzone",
  props: {
    disabled: { type: Boolean },
    pickerAvailable: { type: Boolean, default: !0 },
    multiple: { type: Boolean, default: !0 },
    accept: {},
    label: { default: "Add files" }
  },
  emits: ["files"],
  setup(e, { emit: a }) {
    const t = e, l = a, i = z(), o = z(0), d = (u) => !!(u.dataTransfer?.types.includes("Files") || u.dataTransfer?.files.length), b = j(() => !t.disabled && o.value > 0), k = () => {
      !t.disabled && t.pickerAvailable && i.value?.click();
    }, h = (u) => {
      !t.disabled && u?.length && l("files", Array.from(u));
    }, $ = (u) => {
      d(u) && (u.preventDefault(), u.stopPropagation(), t.disabled || (o.value += 1));
    }, f = (u) => {
      d(u) && (u.preventDefault(), u.stopPropagation(), u.dataTransfer && (u.dataTransfer.dropEffect = t.disabled ? "none" : "copy"));
    }, p = (u) => {
      !d(u) && o.value === 0 || (u.stopPropagation(), o.value = Math.max(0, o.value - 1));
    }, y = (u) => {
      o.value = 0, d(u) && (u.preventDefault(), u.stopPropagation(), h(u.dataTransfer?.files || null));
    };
    return N(() => t.disabled, () => {
      o.value = 0;
    }), (u, w) => (n(), s("div", {
      class: C(["ui-file-dropzone", { "ui-file-dropzone--active": b.value }]),
      "data-drag-active": b.value || void 0,
      onDragenter: $,
      onDragover: f,
      onDragleave: p,
      onDrop: y,
      onDragend: w[1] || (w[1] = (M) => o.value = 0)
    }, [
      e.pickerAvailable ? (n(), s("input", {
        key: 0,
        ref_key: "input",
        ref: i,
        class: "ui-file-dropzone__input",
        type: "file",
        multiple: e.multiple,
        accept: e.accept,
        disabled: e.disabled,
        onChange: w[0] || (w[0] = (M) => {
          h(M.target.files), M.target.value = "";
        })
      }, null, 40, Ut)) : g("", !0),
      c(u.$slots, "default", {
        active: b.value,
        openPicker: k
      }, () => [
        r("button", {
          type: "button",
          class: "ui-file-dropzone__picker",
          disabled: e.disabled || !e.pickerAvailable,
          onClick: k
        }, v(e.label), 9, xt)
      ])
    ], 42, wt));
  }
}), Bt = { class: "ui-filter-menu" }, Ct = { class: "ui-filter-menu__title" }, Mt = {
  key: 0,
  class: "ui-filter-menu__empty",
  role: "status"
}, St = {
  key: 1,
  class: "ui-filter-menu__empty"
}, zt = ["checked", "disabled", "onChange"], Vt = { class: "ui-filter-menu__footer" }, fa = /* @__PURE__ */ m({
  __name: "UiFilterMenu",
  props: {
    modelValue: {},
    options: {},
    label: { default: "Filter options" },
    triggerLabel: { default: "Filter" },
    emptyText: { default: "No options found." },
    loading: { type: Boolean },
    disabled: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: a }) {
    const t = e, l = a, i = j(() => new Set(t.modelValue)), o = (d) => {
      t.disabled || l("update:modelValue", i.value.has(d) ? t.modelValue.filter((b) => b !== d) : [...t.modelValue, d]);
    };
    return (d, b) => (n(), B(Q, { label: e.label }, {
      trigger: U((k) => [
        c(d.$slots, "trigger", se(de(k)), () => [
          D(I, {
            variant: "secondary",
            size: "sm",
            disabled: e.disabled,
            "aria-expanded": k.open,
            "aria-controls": k.controls,
            onClick: k.toggle
          }, {
            default: U(() => [
              V(v(e.triggerLabel), 1)
            ]),
            _: 1
          }, 8, ["disabled", "aria-expanded", "aria-controls", "onClick"])
        ])
      ]),
      default: U(({ close: k }) => [
        r("div", Bt, [
          r("div", Ct, v(e.label), 1),
          e.loading ? (n(), s("div", Mt, "Loading…")) : e.options.length ? (n(!0), s(L, { key: 2 }, F(e.options, (h) => (n(), s("label", {
            key: h,
            class: "ui-filter-menu__option"
          }, [
            r("input", {
              class: "ui-checkbox",
              type: "checkbox",
              checked: i.value.has(h),
              disabled: e.disabled,
              onChange: ($) => o(h)
            }, null, 40, zt),
            r("span", null, v(h), 1)
          ]))), 128)) : (n(), s("div", St, v(e.emptyText), 1)),
          r("footer", Vt, [
            D(I, {
              variant: "ghost",
              size: "sm",
              disabled: e.disabled || !e.modelValue.length,
              onClick: b[0] || (b[0] = (h) => d.$emit("update:modelValue", []))
            }, {
              default: U(() => [...b[1] || (b[1] = [
                V("Clear", -1)
              ])]),
              _: 1
            }, 8, ["disabled"]),
            D(I, {
              variant: "primary",
              size: "sm",
              onClick: k
            }, {
              default: U(() => [...b[2] || (b[2] = [
                V("Done", -1)
              ])]),
              _: 1
            }, 8, ["onClick"])
          ])
        ])
      ]),
      _: 3
    }, 8, ["label"]));
  }
}), Dt = {}, Tt = { class: "ui-floating-action-dock" }, Lt = {
  key: 0,
  class: "ui-floating-action-dock__group"
}, At = {
  key: 1,
  class: "ui-floating-action-dock__group"
};
function Et(e, a) {
  return n(), s(L, null, [
    c(e.$slots, "scrim"),
    r("div", Tt, [
      e.$slots.left ? (n(), s("div", Lt, [
        c(e.$slots, "left")
      ])) : g("", !0),
      e.$slots.right ? (n(), s("div", At, [
        c(e.$slots, "right")
      ])) : g("", !0)
    ])
  ], 64);
}
const ba = /* @__PURE__ */ ee(Dt, [["render", Et]]);
export {
  Qt as UiAlert,
  Y as UiAvatar,
  he as UiBadge,
  I as UiButton,
  ve as UiButtonGroup,
  Ot as UiCheckbox,
  _t as UiCollapsible,
  ua as UiDateTimeField,
  na as UiDialog,
  Xt as UiEmptyState,
  Jt as UiField,
  ca as UiFileDropzone,
  fa as UiFilterMenu,
  ba as UiFloatingActionDock,
  A as UiIconButton,
  Ft as UiInput,
  Wt as UiLink,
  Ye as UiMenu,
  ra as UiMultiSelect,
  ta as UiPanelAction,
  ea as UiPanelSection,
  aa as UiPanelToggle,
  Ee as UiPartControls,
  la as UiPartSection,
  Q as UiPopover,
  It as UiSelect,
  Yt as UiSeparator,
  sa as UiSidePanel,
  we as UiSpinner,
  Zt as UiSurface,
  Rt as UiSwitch,
  oa as UiSyncStatus,
  da as UiTabs,
  Kt as UiTextarea,
  ia as UiUserMenu,
  Gt as chartColors,
  re as colors,
  Ht as dimensions,
  qt as palette,
  Nt as roles,
  ue as semanticColors,
  jt as tokens
};
